import { ref } from 'vue';

const CONSENT_KEY = 'spotify_consent';

// localStorage kann fehlen oder blockiert sein – die Zustimmung gilt dann nur bis zum Neuladen
const readConsent = (): boolean => {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'granted';
  } catch {
    return false;
  }
};

// Modulweit geteilt, damit ein Widerruf im Datenschutz-Abschnitt auch die Spotify-Karte erreicht
const consent = ref(readConsent());

const grant = () => {
  consent.value = true;
  try {
    localStorage.setItem(CONSENT_KEY, 'granted');
  } catch {
    // Zustimmung bleibt für diesen Besuch aktiv
  }
};

const revoke = () => {
  consent.value = false;
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch {
    // Es wurde nichts gespeichert, das entfernt werden müsste
  }
};

export function useSpotifyConsent() {
  return { consent, grant, revoke };
}
